// extracted by mini-css-extract-plugin
module.exports = {"dp-index-bar":"dp-index-bar___1-IkY"};